import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['mode', 'fixed', 'workSchedule']

  connect() {
    this.update()
  }

  update() {
    const isWorkSchedule = this.modeTarget.value === 'work_schedule'
    this.fixedTarget.classList.toggle('hidden', isWorkSchedule)
    this.workScheduleTarget.classList.toggle('hidden', !isWorkSchedule)
  }
}
